import { render } from "./Start.vue?vue&type=template&id=3e7cf56b&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=3e7cf56b&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7cf56b"]])

export default __exports__